<!--
 * @Author: your name
 * @Date: 2021-08-09 16:31:49
 * @LastEditTime: 2021-08-27 15:43:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \malu_pc\malu_pc\src\App.vue
-->
<template>
  <div id="app" class="main">
    <el-backtop style="width:100px;" bottom="70">
      <div style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        /* line-height: 40px; */
        color: #1989fa;
      }">
        回到顶部
      </div>
    </el-backtop>
    <div class="topTabar">
      <a href="https://www.malukeji.com/index.html" alt="码路科技">
        <el-image class="logo" src="https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/static/img/logo.png"
          fit="contain" alt="码路科技"></el-image>
      </a>
      <div class="Navbar">
        <router-link to="/">
          <div class="r_link" @click="activeTab(0)" :class="active == 0 ? 'active' : ''">
            <div>技术开发</div>
          </div>
        </router-link>
        <router-link to="/haibao">
          <div class="r_link" @click="activeTab(1)" :class="active == 1 ? 'active' : ''">
            <div>美术</div>
          </div>
        </router-link>
        <router-link to="/video">
          <div class="r_link" @click="activeTab(2)" :class="active == 2 ? 'active' : ''">
            <div>视频</div>
          </div>
        </router-link>
        <router-link to="/guanyuwomen">
          <div class="r_link" :class="active == 3 ? 'active' : ''" @click="activeTab(3)">
            <div>关于我们</div>
          </div>
        </router-link>
      </div>
    </div>
    <transition name="fade">
      <router-view />
    </transition>
    <!-- <div class="btn_fd" @click="to_top">
      <div><i style="font-size: 40px;" class="el-icon-upload2"></i></div>
      <div>回到顶部</div>
    </div> -->

    <div class="bottomBar" style="font-size: 14px;">
      <a href="https://www.malukeji.com/pc/index.html" alt="码路科技">
        码路科技有限公司</a>
      版权所有
      <a style="color: #409EFF;cursor: pointer;" target="_blank"
        href="https://beian.miit.gov.cn/">冀ICP备2020022811号-1</a>
    </div>
    <div class="bottomBar2">
      <el-image style="width: 16px" src="/static/guohui.png" fit="contain"></el-image>
      <el-link type="primary" target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=13010802002021">
        冀公网安备13010802002021号</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      active: 0,
      h5_url:
        "https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/static/index-selected.png",
      hb_url:
        "https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/static/ori.png",
      gy_url:
        "https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/static/about-us.png",
    };
  },
  methods: {
    activeTab(current) {
      console.log(current)
      if (this.active == current) return;
      this.active = current;
    },
    to_top() {
      window.scrollTo(0, 0)
    }
  },
  mounted() {
    if (this.$route.name == "haibao") {
      this.active = 1;
    }
    if (this.$route.name == "video") {
      this.active = 2;
    }
    if (this.$route.name == "guanyuwomen") {
      this.active = 3;
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.name == "index") {
          this.active = 0;
        }
        if (val.name == "haibao") {
          this.active = 1;
        }
        if (val.name == "video") {
          this.active = 2;
        }
        if (val.name == "guanyuwomen") {
          this.active = 3;
        }
        console.log(oldVal);
        //是否禁止分享
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/common.scss";

.btn_fd {
  position: fixed;
  right: 50px;
  bottom: 100px;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;

  .router-view {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: 0 auto;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .fade-enter {
    visibility: hidden;
    opacity: 0;
  }

  .fade-leave-to {
    display: none;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }

  .fade-enter-to,
  .fade-leave {
    visibility: visible;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue